const setActiveProject = (state, { projectId, activeProject }) => {
  state.activeProjectId = projectId
  state.activeProject = activeProject || null
}
const setError = (state, error) => {
  state.error = error
}
const setOptions = (state, options) => {
  state.options = options || {}
}
const setStatus = (state, status) => {
  state.status = status
}

export default {
  setActiveProject,
  setError,
  setOptions,
  setStatus
}
